export default __webpack_public_path__ + "static/media/Icon awesome-linkedin-in.78231ab5.svg";